import { render, staticRenderFns } from "./p19.vue?vue&type=template&id=a8087b86&scoped=true&"
import script from "./p19.vue?vue&type=script&lang=js&"
export * from "./p19.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8087b86",
  null
  
)

export default component.exports